import React from 'react'
import Table from '../../components/common/Table'
import { MemberAdditionalDocumentDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'
import createMemberAdditionalDocumentActions from '../actionMenus/MemberAdditionalDocumentActions';
import FileIcons from '../common/FileIcons';

interface MemberAdditionalDocumentTableProps {
  data: MemberAdditionalDocumentDTO[];
  handleEdit: (row: MemberAdditionalDocumentDTO) => void;
  handleDelete: (row: MemberAdditionalDocumentDTO) => Promise<void>;
  handleDownload: (row: MemberAdditionalDocumentDTO) => Promise<void>;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
  sortBy?: string;
  sortDescending?: boolean;
  onSort?: (sortKey: string) => void;
}

const MemberAdditionalDocumentTable: React.FC<MemberAdditionalDocumentTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  handleDownload,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
  sortBy,
  sortDescending,
  onSort,
}) => {
  return (
    <Table
      columns={[

        {
          label: "Document Name",
          key: "documentName",
        },

        {
          label: "Document Type",
          key: "documentTypeId",
          render: (row: MemberAdditionalDocumentDTO) => (<span>{row.documentType?.title}</span>),
        },

        {
          label: 'Document',
          key: 'documentId',
          render: (row: MemberAdditionalDocumentDTO) => (
            <FileIcons
              files={[
                {
                  id: row.documentId,
                  label: 'Document',
                },
              ]}
            />
          ),
        },

        {
          label: "Updated",
          key: "updatedUtc",
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },

        {
          label: "Uploaded",
          key: "createdUtc",
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        extra: (row) =>
          createMemberAdditionalDocumentActions({
            onView: handleEdit,
            onDelete: handleDelete,
            onDownload: handleDownload,
          })(row)
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
      sortBy={sortBy}
      sortDescending={sortDescending}
      onSort={onSort}
    />
  );
};

export default MemberAdditionalDocumentTable;
